import "./_appIcon.scss";

import cx from "classnames";
import {ReactElement, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {appIcon} from "types/application";

function AppIcon({
  application,
  onMouseOut,
  onMouseOver,
}: {
  application: appIcon;
  onMouseOut: () => void;
  onMouseOver: () => void;
}): ReactElement {
  const [runAnimation, setRunAnimation] = useState<boolean>(true);
  useEffect(() => {
    const animationTimeout = setInterval(() => {
      setRunAnimation(false);
    }, 800);
    return () => {
      clearInterval(animationTimeout);
    };
  }, []);
  const appNom: JSX.Element = application.image ? (
    <Link to={application.link}>
      <img src={application.image} alt={application.nom || ""} />{" "}
    </Link>
  ) : (
    <p>{application.nom || ""}</p>
  );
  return (
    <div
      className={cx("appIcon", runAnimation ? "appIcon-animation" : "")}
      onMouseOver={() => onMouseOver()}
      onMouseOut={() => onMouseOut()}>
      {appNom}
    </div>
  );
}

export default AppIcon;
